import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Props from '@components/Props';
export const _frontmatter = {
  "name": "Footer",
  "menu": "Components",
  "route": "/components/footer",
  "description": "The API documentation of the Footer React component. Play around with demos and check out its props."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Footer`}</h1>
    <p>{`Do you need a relatively classic and customizable footer? If so, this component was made for you. `}<strong parentName="p">{`Footer`}</strong>{` provides a light
but highly customizable interface so you can build a footer staight out of the box. All the default styling is already handled for you.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Some components used in the following stories like the `}<inlineCode parentName="p">{`<YourOwnBanner>`}</inlineCode>{` or the icons are not included - you
can bring any component of your choosing when you use the Footer.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/footer#"
        }}>{`Footer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/footer#footer-column"
        }}>{`Footer.Column`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/footer#footer-item"
        }}>{`Footer.Item`}</a></li>
    </ul>
    <h2>{`Default`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer title="Awesome footer" bottomBanner={<YourOwnBanner />}>
  <Footer.Column isInline>
    <Footer.Item icon={<AccountCircle />} href="#">
      My Account
    </Footer.Item>
    <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </Footer.Item>
    <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </Footer.Item>
  </Footer.Column>
</Footer>
`}</code></pre>
    <h2>{`A big footer`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer title="Awesome footer" bottomBanner={<YourOwnBanner />}>
  <Footer.Column title="Awesome Column A">
    <Footer.Item icon={<AccountCircle />} href="#">
      My Account
    </Footer.Item>
    <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </Footer.Item>
    <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </Footer.Item>
  </Footer.Column>
  <Footer.Column title="Awesome Column B">
    <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </Footer.Item>
    <Footer.Item icon={<AccountCircle />} href="#">
      My Account
    </Footer.Item>
    <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </Footer.Item>
  </Footer.Column>
  <Footer.Column title="Awesome Column C">
    <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </Footer.Item>
    <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </Footer.Item>
    <Footer.Item icon={<AccountCircle />} href="#">
      My Account
    </Footer.Item>
  </Footer.Column>
</Footer>
`}</code></pre>
    <h2>{`No bottom banner`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer title="Awesome footer">
  <Footer.Column isInline>
    <Footer.Item icon={<AccountCircle />} href="#">
      My Account
    </Footer.Item>
    <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </Footer.Item>
    <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </Footer.Item>
  </Footer.Column>
</Footer>
`}</code></pre>
    <h2>{`Background image`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer
  title="Awesome footer"
  image={{ image: 'https://ak4.picdn.net/shutterstock/videos/3200194/thumb/9.jpg' }}
>
  <Footer.Column>
    <Footer.Item icon={<AccountCircle />} href="#">
      My Account
    </Footer.Item>
    <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </Footer.Item>
    <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </Footer.Item>
  </Footer.Column>
  <Footer.Column>
    <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </Footer.Item>
    <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </Footer.Item>
    <Footer.Item icon={<AccountCircle />} href="#">
      My Account
    </Footer.Item>
  </Footer.Column>
</Footer>
`}</code></pre>
    <h2>{`No title`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer>
  <Footer.Column isInline>
    <Footer.Item icon={<AccountCircle />} href="#">
      My Account
    </Footer.Item>
    <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </Footer.Item>
    <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </Footer.Item>
  </Footer.Column>
</Footer>
`}</code></pre>
    <h2>{`No icons`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer title="Awesome footer">
  <Footer.Column title="Awesome column A">
    <Footer.Item href="#">My Account</Footer.Item>
    <Footer.Item onClick={() => console.log('Starting coding now!')}>Start Coding</Footer.Item>
    <Footer.Item href="lelain-dot-alexandre-at-gmail-dot-com">Contact Us</Footer.Item>
  </Footer.Column>
  <Footer.Column title="Awesome column B">
    <Footer.Item href="lelain-dot-alexandre-at-gmail-dot-com">Contact Us</Footer.Item>
    <Footer.Item onClick={() => console.log('Starting coding now!')}>
      Start Coding now !!
    </Footer.Item>
    <Footer.Item href="#">My Account</Footer.Item>
  </Footer.Column>
</Footer>
`}</code></pre>
    <h2>{`Extended`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedFooter>
  <ExtendedColumn isInline>
    <ExtendedItem icon={<AccountCircle />} href="#">
      My Account
    </ExtendedItem>
    <ExtendedItem icon={<Code />} onClick={() => console.log('Starting coding now!')}>
      Start Coding
    </ExtendedItem>
    <ExtendedItem icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
      Contact Us
    </ExtendedItem>
  </ExtendedColumn>
</ExtendedFooter>
`}</code></pre>
    <h2>{`Props`}</h2>
    <Props of="Footer" mdxType="Props" />
    <br />
    <hr />
    <h2>{`Footer.Column`}</h2>
    <h3>{`Default Column`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer.Column style={{ width: 'max-content', backgroundColor: "#1976d2" }}>
  <Footer.Item icon={<AccountCircle />} href="#">
    My Account
  </Footer.Item>
  <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
    Start Coding
  </Footer.Item>
  <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
    Contact Us
  </Footer.Item>
</Footer.Column>
`}</code></pre>
    <h3>{`With a title`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer.Column title="Awesome title" style={{ width: 'max-content', backgroundColor: "#1976d2" }}>
  <Footer.Item icon={<AccountCircle />} href="#">
    My Account
  </Footer.Item>
  <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
    Start Coding
  </Footer.Item>
  <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
    Contact Us
  </Footer.Item>
</Footer.Column>
`}</code></pre>
    <h3>{`Inline`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer.Column title="Awesome title" isInline style={{ width: 'max-content', backgroundColor: "#1976d2" }}>
  <Footer.Item icon={<AccountCircle />} href="#">
    My Account
  </Footer.Item>
  <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
    Start Coding
  </Footer.Item>
  <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
    Contact Us
  </Footer.Item>
</Footer.Column>
`}</code></pre>
    <h3>{`Extended`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedColumn title="Awesome title" isInline>
  <Footer.Item icon={<AccountCircle />} href="#">
    My Account
  </Footer.Item>
  <Footer.Item icon={<Code />} onClick={() => console.log('Starting coding now!')}>
    Start Coding
  </Footer.Item>
  <Footer.Item icon={<Email />} href="lelain-dot-alexandre-at-gmail-dot-com">
    Contact Us
  </Footer.Item>
</ExtendedColumn>
`}</code></pre>
    <h3>{`Props`}</h3>
    <Props of="Footer.Column" mdxType="Props" />
    <br />
    <hr />
    <h2>{`Footer.Item`}</h2>
    <h3>{`Default Item`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer.Item icon={<AccountCircle />} href="#" style={{ width: 'max-content', backgroundColor: "#1976d2" }}>
  My Account
</Footer.Item>
`}</code></pre>
    <h3>{`As a button`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Footer.Item icon={<AccountCircle />} onClick={() => console.log('clicked!')} style={{ width: 'max-content', backgroundColor: "#1976d2" }}>
  My Account
</Footer.Item>
`}</code></pre>
    <h3>{`Extended`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedFooterItem icon={<Email />} href="#">
  I'm a button
</ExtendedFooterItem>
`}</code></pre>
    <h3>{`Props`}</h3>
    <p>{`This component extends Material's UI `}<inlineCode parentName="p">{`<Button>`}</inlineCode>{` so you can use all its props as well. Check out its `}<a parentName="p" {...{
        "href": "https://material-ui.com/api/button/"
      }}>{`Api`}</a>{`.`}</p>
    <Props of="Footer.Item" mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      